export const getResponsiveImageUrl = (source, { width, quality = 78 } = {}) => {
  if (!source || !width) return source;

  try {
    const imageUrl = new URL(source);

    if (imageUrl.hostname === 'images.unsplash.com') {
      imageUrl.searchParams.delete('fm');
      imageUrl.searchParams.set('auto', 'format');
      imageUrl.searchParams.set('fit', 'crop');
      imageUrl.searchParams.set('w', String(width));
      imageUrl.searchParams.set('q', String(quality));
      return imageUrl.toString();
    }

    if (imageUrl.hostname === 'images.pexels.com') {
      imageUrl.searchParams.set('auto', 'compress');
      imageUrl.searchParams.set('cs', 'tinysrgb');
      imageUrl.searchParams.set('w', String(width));
      return imageUrl.toString();
    }
  } catch {
    return source;
  }

  return source;
};
